import { Field, Form, Formik } from "formik";
import { useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import * as Yup from "yup";

function ResumeForm({
  user,
  otherError,
  coverLetter,
  selectedOption,
  fileInputRef,
  handleRequest,
  handleFileChange,
  setSelectedOption,
  setCoverLetter,
  setShowTiers,
  userTokenData,
  isSuccessful,
}) {
  const [toolTip, setTootTip] = useState(false);
  const FormSchema = Yup.object().shape({
    fullname: Yup.string()
      .trim()
      .min(3, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    email: Yup.string().trim().email("Invalid email").required("Required"),
    jobtitle: Yup.string()
      .trim()
      .min(3, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    jobpostlink: Yup.string().trim().url(),
    jobdescription: Yup.string()
      .trim()
      .min(400, "Too Short!")
      .max(700, "Too Long!"),
  });

  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "text-deepGrey",
  };

  return (
    <Formik
      initialValues={{
        fullname: "",
        email: "",
        jobtitle: "",
        jobpostlink: "",
        jobdescription: "",
      }}
      validationSchema={FormSchema}
      onSubmit={async (values, { resetForm }) => {
        handleRequest(values, resetForm);
        // resetForm();
      }}
    >
      {({ errors, touched }) => {
        return (
          <Form className="flex flex-col gap-y-1 border-[0.5px] border-white/5 px-5 pt-5 pb-1 rounded-xl text-sm">
            <div className="w-full mb-3">
              <p className="text-white/70">
                Full Name <span className="text-red-600">*</span>
              </p>
              <Field
                id="fullname"
                name="fullname"
                placeholder="full name"
                type="text"
                className={`w-full p-2 border-[0.5px] placeholder:text-start focus:ring-0 focus:border-neutral-600 rounded-xl bg-black/20 text-sm ${
                  errors.fullname && touched.fullname
                    ? "border-red-900"
                    : "border-white/5"
                }`}
              />
            </div>
            <div className="w-full mb-3">
              <p className="text-white/70">
                Email Address <span className="text-red-600">*</span>
              </p>
              <Field
                id="email"
                name="email"
                placeholder="email"
                type="text"
                className={`w-full p-2 border-[0.5px] placeholder:text-start focus:ring-0 focus:border-neutral-600 rounded-xl bg-black/20 text-sm ${
                  errors.email && touched.email
                    ? "border-red-900"
                    : "border-white/5"
                }`}
              />
            </div>
            <div className="w-full mb-3">
              <p className="text-white/70">
                Job Title <span className="text-red-600">*</span>
              </p>
              <Field
                id="jobtitle"
                name="jobtitle"
                placeholder="job title"
                type="text"
                className={`w-full p-2 border-[0.5px] placeholder:text-start focus:ring-0 focus:border-neutral-600  rounded-xl bg-black/20 text-sm ${
                  errors.jobtitle && touched.jobtitle
                    ? "border-red-900"
                    : "border-white/5"
                }`}
              />
            </div>
            <div className="w-full mb-3">
              <p className="text-white/70">Job Post Link</p>
              <Field
                id="jobpostlink"
                name="jobpostlink"
                placeholder="job post link"
                type="text"
                className={`w-full p-2 border-[0.5px] placeholder:text-start focus:ring-0 focus:border-neutral-600  rounded-xl bg-black/20 text-sm ${
                  errors.jobpostlink && touched.jobpostlink
                    ? "border-red-900"
                    : "border-white/5"
                }`}
              />
            </div>
            <div className="w-full mb-3 relative">
              <p className="text-white/70">Job Description</p>
              <Field
                id="jobdescription"
                name="jobdescription"
                placeholder="job description"
                type="text"
                className={`w-full p-2 border-[0.5px] placeholder:text-start focus:ring-0 focus:border-neutral-600  rounded-xl bg-black/20 text-sm ${
                  errors.jobdescription && touched.jobdescription
                    ? "border-red-900"
                    : "border-white/5"
                }`}
              />
              <p className="text-white/70 text-end mr-2 text-[10px] tracking-wider">
                700 Maximum Characters Allowed
              </p>
            </div>
            <p className="text-white/70">
              Resume | PDF ONLY <span className="text-red-600">*</span>
            </p>
            <div
              className={`border-[0.5px] bg-black/20 rounded-xl p-3 ${
                otherError.resume ? "border-red-900" : "border-white/5"
              }`}
            >
              <input
                ref={fileInputRef}
                type="file"
                multiple
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
                className="block w-fit text-sm file:mr-4 file:py-1 file:text-[10px] file:px-2 file:rounded-lg file:border-0 file:bg-linesLighter file:text-white/70 focus:outline-none file:font-thin ring-0 !ring-offset-0 focus:ring-0"
              />
            </div>
            <ul
              className={`flex flex-col gap-3 my-3 border-[0.5px] p-3 rounded-xl bg-black/20 ${
                otherError.selectedOption ? "border-red-900" : "border-white/5"
              }`}
            >
              <li>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="resumeOption" // same name = only one selectable
                    value="Suggest Improvements"
                    checked={selectedOption === "Suggest Improvements"}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    className="ml-2 bg-transparent rounded-[4px] ring-0 !ring-offset-0 focus:ring-0"
                  />
                  <span className="ml-2">Suggest Improvements</span>
                </label>
              </li>
            </ul>
            <ul className="flex flex-col gap-3 mb-3 border-[0.5px] border-white/5 p-3 rounded-xl bg-black/20">
              <div className="flex flex-row items-start justify-between text-[10px]">
                <div className="flex flex-row items-center">
                  <span className="bg-indigo-700 w-fit px-[5px] py-[2px] font-normal text-white/60 rounded-sm">
                    Premium $
                  </span>
                  {!user || Object.keys(user).length === 0 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-3 ml-2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-3 ml-2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  )}
                </div>
                {userTokenData?.token > 0 ? (
                  <div className="flex flex-col items-center gap-[3px]">
                    <p className="text-[10px]">
                      <span className="font-semibold">
                        {userTokenData?.token}
                      </span>{" "}
                      TOKENS
                    </p>
                    <div
                      onClick={() => user && setShowTiers(true)}
                      className="w-fit cursor-pointer hover:border-white/5 hover:text-white/20 transition-all duration-500 px-[5px] py-[2px] text-white/70 font-thin tracking-wider rounded-[4px] border-[0.5px] border-white/20"
                    >
                      <p>Top Up Token</p>
                    </div>
                  </div>
                ) : (
                  <div
                    onMouseOver={() => !user && setTootTip(true)}
                    onMouseLeave={() => !user && setTootTip(false)}
                  >
                    <div
                      onClick={() => user && setShowTiers(true)}
                      className="relative w-fit cursor-pointer hover:border-white/5 hover:text-white/20 transition-all duration-500 px-[5px] py-[2px] text-white/70 font-thin tracking-wider rounded-[4px] border-[0.5px] border-white/20"
                    >
                      <p>Buy Tokens</p>
                    </div>
                    {toolTip && !user && (
                      <p className="absolute">Sign In to Buy</p>
                    )}
                  </div>
                )}
              </div>
              <li>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="resumeOption"
                    value="Rewrite Resume Completely"
                    checked={selectedOption === "Rewrite Resume Completely"}
                    onChange={(e) => user && setSelectedOption(e.target.value)}
                    className="ml-2 bg-transparent rounded-[4px] ring-0 !ring-offset-0 focus:ring-0"
                  />
                  <span className="ml-2">Rewrite Resume Completely</span>
                </label>
              </li>
              <li>
                <label className="flex items-center">
                  <input
                    name="cover letter"
                    checked={coverLetter}
                    onChange={(e) => setCoverLetter(e.target.checked)}
                    disabled={!user || Object.keys(user).length === 0}
                    type="checkbox"
                    className="ml-2 bg-transparent rounded-[4px] ring-0 !ring-offset-0 focus:ring-0"
                  />
                  <span className="ml-2">Cover Letter</span>
                </label>
              </li>
            </ul>
            <div className="w-full h-[40px] mx-auto flex flex-row justify-center mb-2">
              {isSuccessful ? (
                <ClipLoader
                  color="text-lightGrey"
                  loading={isSuccessful}
                  cssOverride={override}
                  size={20}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              ) : (
                <button
                  type="submit"
                  className="py-2 w-fit px-5 rounded-lg bg-blue-600 text-white"
                >
                  Submit
                </button>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ResumeForm;
